import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://thinkway-api-producao.onrender.com'
});

api.interceptors.request.use(
    config => {
        const token = localStorage.getItem('@ThinkWay:token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
  response => response,
  error => {
    // Handle 402 Payment Required - redirecionar para página de pagamento
    // MAS APENAS se needsPayment for true (não tem acesso gratuito)
    if (error.response?.status === 402) {
      const errorData = error.response.data || {};
      
      // Não redirecionar se já estiver na página de pagamento (evitar loop infinito)
      const currentPath = globalThis.location.pathname;
      if (currentPath.includes('/pagamento')) {
        return Promise.reject(error);
      }
      
      // Verificar se realmente precisa de pagamento
      if (errorData.needsPayment) {
        globalThis.location.href = '/tw/pagamento';
        return Promise.reject(error);
      }
    }
    
    // Handle 401 errors globally (expired token)
    if (error.response?.status === 401) {
      const errorMessage = error.response.data?.message || error.response.data?.error || '';
      
      // Se for erro de permissão, não redirecionar
      if (errorMessage.toLowerCase().includes('permiss') || 
          errorMessage.toLowerCase().includes('acesso') ||
          errorMessage.toLowerCase().includes('permission')) {
        return Promise.reject(error);
      }
      
      // Se for erro de token, redirecionar para login
      localStorage.removeItem('@ThinkWay:token');
      globalThis.location.href = '/tw/login';
    }
    return Promise.reject(error);
  }
);

export default api;
